
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/meetings/meet/[quickMeetId]/edit",
      function () {
        return require("private-next-pages/admin/meetings/meet/[quickMeetId]/edit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/meetings/meet/[quickMeetId]/edit"])
      });
    }
  